import { Component, OnInit } from '@angular/core';
import { NgForm, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';

//components
import { NotificationComponent } from '../notification/notification.component';

//services
import { AuthService } from '../shared/auth.service';
import { BackendService } from '../shared/backend.service';
import { NotificationService } from '../notification/notification.service';
import { ResetFormService } from './reset-form.service';
import { AppService } from 'app/app.service';
import { AlertmessageService } from 'app/shared/alertmessage.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  providers: [ResetFormService]
})

export class LoginComponent implements OnInit {
    loginUser: FormGroup;
    submitted: Boolean = false;
    intendedRoute: string;

    constructor(
        public _authService: AuthService,
        public _backendService: BackendService,
        public _router: Router,
        public _formBuilder: FormBuilder,
        public _notificationService: NotificationService,
        public _resetFormService: ResetFormService,
        public _appService:AppService,
        public _alert: AlertmessageService,
    ) {
        this.setForm();
    }

    ngOnInit() {
        this._appService.setUserLoggedIn(false);
    }

    login(user) {
       // console.log(user);
       user.CustomerID=btoa(user.CustomerID);
        //allow us to check if user has submitted form- for validation display
        this.submitted = true;
        console.log(user)
        if (this.loginUser.valid) {
           // this._appService.setUserLoggedIn(true);
            this._authService.login(user)
               
                .subscribe(response => {
                    console.log('login response:', response);
                    if (response.result) {
                        this._notificationService.showNotification({ type: 'success', message: response.msg });
                        this._authService.isLoggedIn = true;

                        if (user.rememberMe) {
                            localStorage.setItem('CustomerID', atob(response.custID));
                            this._authService.CustomerID = localStorage.getItem('CustomerID');
                            localStorage.setItem('token', response.access_token);
                            this._authService.token = localStorage.getItem('token');
                             localStorage.setItem('CustomerType', response.customerType);
                             //console.log(response.customerType);
                        } else {
                            sessionStorage.setItem('CustomerID', atob(response.custID));
                            this._authService.CustomerID = sessionStorage.getItem('CustomerID');
                            localStorage.setItem('token', response.access_token);
                            sessionStorage.setItem('token', response.access_token);
                            this._authService.token = sessionStorage.getItem('token');
                             localStorage.setItem('CustomerType', response.customerType);
                           //  console.log(response.customerType);
                        }

                        //reset submission flag to false
                        this.submitted = false;
                     
                        //console.log(response);
                        //console.log(response.requirePasswordChange);
                        
                        if(response.requirePasswordChange == 1) {
                           // console.log("tkksdfnk")
                            this._notificationService.showNotification({ type: 'warning', message: 'Please reset your password' });
                           return  this._router.navigate(['/set-security-questions']);
                        }
                        this._notificationService.showNotification({ type: 'success', message: response.msg });
                        //redirect logged in user to the main dashboard
                      this._router.navigate(['/dashboard']);
                    } else {
                        this.loginUser.controls['CustomerID'].setValue('');
                        this.loginUser.controls['Password'].setValue('');
                        //this._notificationService.showNotification({ type: 'error', message: response['msg'] });
                        this._alert.openConfirmationDialogTimeOut(response['msg']);
                    }
                },
                //server error
                (error) => {
                    this._notificationService.showNotification({ type: 'error', message: 'Server Error' });
                });
        } else {
            //validators (below) handle errors in form, no action necessary for now
            console.log('login form error');
        }
    }
    forgot(){
        console.log('anil');
    }

    activateSubRoute(rt) {
       // console.log(rt);
        this._router.navigate(['/dashboard'], { preserveQueryParams: true });
    }

    setForm() {
        /*
        Used for initial creation of form validors.
        On submission, must be reset individually
        (see login function's 'bad password' branch above).
        */

        /*
        Each field needs a validator- if no validation necessary, leave 2nd parameter blank.  
        If you need multiple validators, pass an array of validators as 2nd parameter  
        Can also initialize form field to a value (first parameter to the Control method)
        */
        this.loginUser = this._formBuilder.group({
            'CustomerID': ['', Validators.required],
            'Password': ['', Validators.required],
            
        });
    }
}
